var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 1.5625H6.1875C5.25552 1.5625 4.5 2.31802 4.5 3.25V16.75C4.5 17.682 5.25552 18.4375 6.1875 18.4375H11.8125C12.7445 18.4375 13.5 17.682 13.5 16.75V3.25C13.5 2.31802 12.7445 1.5625 11.8125 1.5625Z",
    stroke: "#FFDB70",
    strokeWidth: 1.23047,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 1.5625H7.03125C7.10584 1.5625 7.17738 1.59213 7.23012 1.64488C7.28287 1.69762 7.3125 1.76916 7.3125 1.84375C7.3125 1.99293 7.37176 2.13601 7.47725 2.2415C7.58274 2.34699 7.72582 2.40625 7.875 2.40625H10.125C10.2742 2.40625 10.4173 2.34699 10.5227 2.2415C10.6282 2.13601 10.6875 1.99293 10.6875 1.84375C10.6875 1.76916 10.7171 1.69762 10.7699 1.64488C10.8226 1.59213 10.8942 1.5625 10.9688 1.5625H11.8125",
    stroke: "#FFDB70",
    strokeWidth: 1.23047,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.98d15c65e8c26816c431c5175c23f8bb.svg";
export { ForwardRef as ReactComponent };